(ns teamoesterreich.admin-mode.user.user-card-log

  (:require [clojure.string]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.data.logs :as d-logs]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]

            ))





(defn get-it [!actual-user]
  (let [tomId (:user-tomId @!actual-user)
        user-uuid (:user-uuid @!actual-user)
        !st (r/atom {:logs nil :loaded false :tomId 0})
        !tomId (r/cursor !st [:tomId])
        !logs (r/cursor !st [:logs])
        !loaded (r/cursor !st [:loaded])]
    (fn []
      (log/debug "Logs " (not (true? @!loaded)) (not= @!tomId tomId) (clj->js @!logs))
      (if (or (not (true? @!loaded)) (not= @!tomId tomId))
        ;not loaded
        (do
          (d-logs/<get-user-log-list tomId
                                     (fn [data] (swap! !st assoc
                                                       :logs data
                                                       :loaded true
                                                       :tomId tomId)))
          [mui/card {:style {:textAlign "left" :marginTop "10px"}}
           [mui/card-header
            {:title (str "Loading Logs.. " tomId)}]
           ])

        ;is loaded
        [mui/card {:style {:textAlign "left" :marginTop "10px"}}
         [ws-event-sync-component/ws-event-reload !loaded :user user-uuid]

         [mui/card-content
          [mui/table
           [mui/table-head
            [mui/table-row
             [mui/table-cell "Datum"]
             [mui/table-cell "Bearbeiter"]
             [mui/table-cell "Beschreibung"]
             ]]

           [mui/table-body
            (for [[uuid entry] (reverse (sort-by (fn [[k v]] (:log-date v))
                                                 (filter (fn [[k v]] (not= (str (:log-message v)) "")) @!logs)))]
              ^{:key (str "log-" uuid)}
              [mui/table-row
               [mui/table-cell (h/date-time-ger-fromT (:log-date entry))]
               [mui/table-cell (str (get-in entry [:log-admin :user-firstName]) " " (get-in entry [:log-admin :user-lastName]))]
               [mui/table-cell [:pre (:log-message entry)]]
               ])
            ]
           ]
          ]
         ]
        )
      )))